import type { AccountUser, Profile } from '@models/session';

import { formatName } from '@utils/format';

export const getSortedProfiles = (profiles: Profile[], user_id: string) => {
  const currentProfile = profiles.filter(({ user_id: id }) => id === user_id);
  const otherProfiles = profiles
    .filter(({ user_id: id }) => id !== user_id)
    .sort((a, b) => {
      const nameA = formatName(a.first_name, a.last_name) ?? '';
      const nameB = formatName(b.first_name, b.last_name) ?? '';
      return nameA.localeCompare(nameB);
    });
  return currentProfile.concat(otherProfiles);
};

export const sortProfiles = (profiles: AccountUser[], user_id: string) =>
  profiles.slice().sort((profileA, profileB) => {
    if (profileA.user_id === user_id) {
      return -1;
    }
    const nameA = formatName(profileA.first_name, profileA.last_name) ?? '';
    const nameB = formatName(profileB.first_name, profileB.last_name) ?? '';
    return nameA.localeCompare(nameB);
  });
